<template>
    <div class="body">
        <div class="banner">
            <img :src="banner">
        </div>
        <div class="contents" v-if="bannerList&&bannerList.length>0">
            <ul class="contents-ul">
                <router-link class="contents-li"   tag="li" v-for="(mbanner,index) in bannerList.slice(1,6)" :key="index" :to="{name:'brand',params:{id:mbanner.id}}"><img :src="mbanner.image">
                </router-link>   
            </ul>
             <ul class="contents-ul contents-ul2">
                <router-link class="contents-li" title="即将上新，敬请期待"  tag="li" v-for="(mbanner,index) in bannerList.slice(6)" :key="index" :to="{name:'brand',params:{id:mbanner.id}}"><img :src="mbanner.image">
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data(){ 
        return{
            banner:"/static/brand/banner.png",
            bannerList:{}
        }
    },
    methods:{
        getclasslist(){
            this.$api.index.getIndexBrand().then((res)=>{            
                this.bannerList = res.data.datas;
            })
        },
    },
    mounted(){
        this.getclasslist();
    }

}
</script>

<style  scoped>
    
    .body{
        background-color: #fff;
    }
    .banner{
        width: 100%;
    }
    .banner img{
        width: 100%;
    }
    .contents-ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        background-color: #fff;

        margin: 50px auto;
        margin-bottom: 0;
        align-items: center;
        
    }
    .contents-ul2{
        /* width: 80%; */
        margin: 10px auto;
        margin-bottom: 70px;
    }
    
    .contents-ul .contents-li{
        width: 216px;
        height: 144px;
        cursor:pointer;
        margin:10px 0;
        border-radius: 10px;
        overflow: hidden;
    }
    
    .contents-ul .contents-li:hover{
       box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
    }
    .contents-ul .contents-li img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/brand/list.vue